"use client";
import * as React from "react";
const SvgRefreshRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.64 2.35A8 8 0 0 0 7.16.05a8 8 0 0 0-7.1 7.01A7.98 7.98 0 0 0 8 16a8 8 0 0 0 7.21-4.56 1 1 0 0 0-1.78-.9 6 6 0 0 1-6.8 3.3 6 6 0 0 1-4.48-4.52A6 6 0 0 1 8 2c1.66 0 3.14.7 4.22 1.78l-1.5 1.51A1 1 0 0 0 11.4 7h3.58a1 1 0 0 0 1-1V2.41a1 1 0 0 0-1.7-.7z" }));
export {
  SvgRefreshRound as default
};
